import React, { PropsWithChildren, ReactNode } from 'react';
import { createPortal } from 'react-dom';

interface ComponentProps {
  visible: boolean;
  header: string | ReactNode;
  onHide: () => void;
  width?: string;
  height?: string;
  fixedContent?: ReactNode;
  // Zavřít kliknutím mimo dialog (na pozadí). U formulářů s více poli vypnout, ať se neztratí rozdělaná práce.
  closeOnBackdrop?: boolean;
}

const Modal: React.FC<PropsWithChildren<ComponentProps>> = ({ visible, onHide, children, header, width = 'w-[1200px]', height = 'max-h-[90vh]', fixedContent, closeOnBackdrop = true }) => {
  const isReactNode = (node: string | ReactNode): node is ReactNode => {
    return typeof node !== 'string';
  };

  return createPortal(
    <>
      <div
        id="product-detail-modal"
        className={`${visible === true ? 'visible' : 'hidden'} fixed inset-0 bg-black bg-opacity-50 z-[110] flex items-center justify-center`}
        onClick={closeOnBackdrop ? onHide : undefined}
      >
        <div className={`modal-content bg-white ${width} ${height} flex flex-col gap-primary`} onClick={e => e.stopPropagation()}>
          <div className="flex items-center justify-between p-0 px-primary pt-primary flex-shrink-0">
            <div>{isReactNode(header) ? header : <h2 className="text-xl font-medium text-gray-900">{header}</h2>}</div>
            <button onClick={() => onHide()} className="text-gray-500 hover:text-gray-700">
              <i className="fa-solid fa-xmark text-xl"></i>
            </button>
          </div>
          {fixedContent && <div className="px-primary flex-shrink-0">{fixedContent}</div>}
          <div className={'flex flex-col gap-2 p-primary pt-0 overflow-y-auto'}>{children}</div>
        </div>
      </div>
    </>,
    document.body,
  );
};

export default Modal;
